import {
  Button,
  Container,
  Divider,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { useRouter } from 'next/router';
import FaqAccordion from 'src/components/FAQAccordion/FaqAccordion';
import Footer from 'src/components/Footer';
import LayoutV2 from 'src/components/LayoutV2';
import AccountMenu from 'src/components/LayoutV2/account-menu';
import Header from 'src/components/LayoutV2/header';
import Back from 'src/components/LayoutV2/header/back';
import Logo from 'src/components/LayoutV2/header/logo';
import { GIFT_CARD_FAQ } from 'src/constants/gift-cards';

const GiftCardPage = () => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery<Theme>((theme) =>
    theme.breakpoints.down('md'),
  );
  const router = useRouter();
  return (
    <LayoutV2
      header={
        <Header
          leftContent={
            <>
              <Back onClickCallback={() => router.push('/dashboard')} />
              <Logo />
            </>
          }
          rightContent={<AccountMenu />}
        />
      }
      footer={<Footer isShowingCart={false} />}
    >
      <Container disableGutters={isSmallScreen}>
        <Grid
          container
          rowSpacing={4}
          sx={{
            marginTop: '1rem',
            padding: '0 1rem',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <Grid>
            <Typography variant="h4">
              Share the Joy of Convenient, Healthy Eating
            </Typography>
          </Grid>
          <Grid>
            <Typography variant="body1">
              Send your friends and family a gift card to order healthy,
              chef-prepared meals delivered to their door.
            </Typography>
          </Grid>
          <Grid
            sx={{
              width: isSmallScreen ? '100%' : '25rem',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-around',
              alignItems: 'center',
            }}
          >
            <Button
              variant="contained"
              sx={{ fontSize: '1rem' }}
              href="/gift-card/selection"
            >
              Buy gift card
            </Button>
            <Button
              variant="outlined"
              sx={{ fontSize: '1rem' }}
              href="/gift-card/redeem"
            >
              Redeem gift card
            </Button>
          </Grid>
          <Grid
            sx={{
              marginTop: '2rem',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Divider
              sx={{
                width: '90%',
                height: '1px',
                borderColor: theme.palette.divider,
              }}
            />
          </Grid>
          <Grid
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5" sx={{ margin: '2rem 0' }}>
              Frequently Asked Questions
            </Typography>
            <FaqAccordion faq={GIFT_CARD_FAQ} />
          </Grid>
        </Grid>
      </Container>
    </LayoutV2>
  );
};
export default GiftCardPage;
